import { render } from "./ThumbsUpButton.vue?vue&type=template&id=264b40e1"
import script from "./ThumbsUpButton.vue?vue&type=script&lang=js"
export * from "./ThumbsUpButton.vue?vue&type=script&lang=js"
script.render = render

export default script